import { render, staticRenderFns } from "./squad_mission_wcinfo.vue?vue&type=template&id=023bf42e"
import script from "./squad_mission_wcinfo.vue?vue&type=script&lang=js"
export * from "./squad_mission_wcinfo.vue?vue&type=script&lang=js"
import style0 from "./squad_mission_wcinfo.vue?vue&type=style&index=0&id=023bf42e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports